"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLoadingMask = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LoadingMaskMixin = require("../../mixins/components/LoadingMaskMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledLoadingMask = /*#__PURE__*/(0, _styledComponents.default)('div').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['display'])
}).withConfig({
  displayName: "StyledLoadingMask",
  componentId: "c11n-8-107-0__sc-1h8a6se-0"
})(["", ""], _LoadingMaskMixin.LoadingMaskMixin);
exports.StyledLoadingMask = StyledLoadingMask;